export default __webpack_public_path__ + "static/media/04__o_3.5c1f2388.jpg";